// extracted by mini-css-extract-plugin
module.exports = {"remarksContainer":"EmployeeRemarksShow__remarksContainer--26vjo"};